var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, ButtonBase, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import FilterHeading from './filter-heading';
import { File01Icon } from 'hugeicons-react';
import { useNavigate } from 'react-router-dom';
import useTranslate from '../../../../../localization/helpers';
import { GlobalSearchModule } from '../../../../../application/common/enums/global-search-module';
import { useAppDispatch, useAppSelector } from '../../../../../application/store/useStore';
import { setFilePath, setFileResults, setIsOpenDialog } from '../../../../../application/features/global-search/globalSearchSlice';
import { useEffect, useMemo } from 'react';
import { graphApi } from '../../../../../application/features/microsoft-graph/microsoft-graph-api';
import { useGlobalSearchStream } from '../../../../../application/features/global-search/document-search-api';
var FileChipSummary = function (_a) {
    var _b;
    var searchTerm = _a.searchTerm, isShowViewAll = _a.isShowViewAll, iconWidth = _a.iconWidth;
    var theme = useTheme();
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var dispatch = useAppDispatch();
    var translate = useTranslate().translate;
    var navigate = useNavigate();
    var fileResults = useAppSelector(function (state) { return state.globalSearch.fileResults; });
    var isMd = useMediaQuery(theme.breakpoints.down('lg'));
    var zoomLevel = useMemo(function () { return (isMd ? 0.2 : 0.8); }, [isMd]);
    var isStreaming = useGlobalSearchStream({
        searchText: searchTerm,
        companyId: (_b = currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id) !== null && _b !== void 0 ? _b : null,
        currentUser: currentUser
    }).isStreaming;
    var handleClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var previewUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, graphApi.getPreviewUrl(item.filePath, '1', zoomLevel)];
                case 1:
                    previewUrl = _a.sent();
                    dispatch(setFilePath(previewUrl));
                    dispatch(setIsOpenDialog(true));
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        dispatch(setFileResults([]));
    }, [dispatch]);
    var handleClickAll = function () {
        navigate("/search?query=".concat(searchTerm, "&module=").concat(GlobalSearchModule.Files));
    };
    if (!isStreaming && (!fileResults || fileResults.length === 0)) {
        return (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', children: _jsx(Typography, { variant: 'body2', color: theme.palette.text.primary, children: translate('common.noRecordFound') }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FilterHeading, { heading: "".concat(fileResults.length, " ").concat(translate('common.indepth')), onButtonClick: handleClickAll, isShowViewAll: isShowViewAll }), _jsxs(Box, { children: [fileResults.map(function (item, index) { return (_jsx(ButtonBase, { onClick: function () { return handleClick(item); }, sx: { width: '100%', textAlign: 'left', borderRadius: '12px' }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', padding: '8px 12px', boxShadow: theme.shadows[4], width: '100%', marginBottom: 1, borderRadius: '12px', children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', children: _jsx(Typography, { variant: 'body2', color: theme.palette.text.primary, dangerouslySetInnerHTML: { __html: item.fileName } }) }), _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1, width: '100%', mt: 0.5, children: [_jsx(File01Icon, { width: iconWidth, color: theme.palette.text.disabled }), _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, dangerouslySetInnerHTML: { __html: item.summary } })] })] }) }, index)); }), isStreaming && (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', children: _jsx(CircularProgress, {}) }))] })] }));
};
export default FileChipSummary;
